import { Refresh, Error } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';

import { ErrorStateProps } from './ErrorState.types';

import './ErrorState.css';

/**
 * ErrorState Component
 *
 * Displays an error state with icon, message, and optional retry button.
 * Used for displaying data loading errors or API failures.
 */
export const ErrorState = ({ message = 'Помилка завантаження даних', onRetry }: ErrorStateProps) => {
  return (
    <Box className="error-state-container">
      <Box className="error-state-content">
        <Error className="error-state-icon" />
        <Typography variant="h5" className="error-state-title">
          {message}
        </Typography>
        <Typography variant="body1" className="error-state-description">
          Сервер не відповідає або повернув помилку. Спробуйте оновити сторінку.
        </Typography>
        {onRetry && (
          <Button variant="contained" startIcon={<Refresh />} onClick={onRetry} className="error-state-button">
            Спробувати знову
          </Button>
        )}
      </Box>
    </Box>
  );
};
